// eslint-disable-next-line import/no-cycle
import {
  WidgetTypeConfig,
  ConfigurationPanelStructureItemEnum,
  ComponentNameEnum,
  FacebookMessengerSkins,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import { getAttributeByName, getClassByName, isMediaDisplayAlreadyRestricted } from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import {
  setAttribute,
  setFacebookMessengerSkin, setMediaDisplay,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import getDropdownFieldConfig from '@/components/template-builder/config/fields/dropdown-config';
// eslint-disable-next-line import/no-cycle
import mediaDisplayFieldConfig from '@/components/template-builder/config/fields/media-display-config';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import { HIDE_MOBILE_ATTRIBUTE } from '@/components/template-builder/utils/constants';
// eslint-disable-next-line import/no-cycle
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';

const widgetFacebookMessengerConfig: WidgetTypeConfig = {
  tabPanel: {
    label: 'templateBuilder.widgetsHeaders.facebookMessenger',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.widgetConfiguration',
        selector: 'body #spm_body #{ID}',
        items: [
          {
            label: 'templateBuilder.informations.facebookDeprecated',
            selector: '',
            properties: [],
            componentName: ComponentNameEnum.INFORMATION,
            options: {
              severity: 'warn',
            },
          },
          {
            label: 'templateBuilder.fields.facebookMessengerTheme.theme',
            selector: '{SELECTOR} .fb-messenger-checkbox',
            properties: [
              { name: 'skin', getter: getAttributeByName, setters: [setAttribute, setFacebookMessengerSkin] },
            ],
            ...getDropdownFieldConfig(Object.values(FacebookMessengerSkins)
              .map((skin) => ({ value: skin, label: `templateBuilder.fields.facebookMessengerTheme.options.${skin}` })), FacebookMessengerSkins.LIGHT),
          },
        ],
      },
      getWidgetCommonStylesGroup(),
    ],
  },
};

export default widgetFacebookMessengerConfig;
